import React, { Fragment } from 'react';

const ItemDisplayConfirmed = ({
    itemImage,
    itemTitle,
    formattedPrice,
    itemUrl
}) => {
    return (
        <Fragment>
            <div className="row mt-4 mb-5 d-none d-md-block">
                <div className="col-10 offset-1 d-flex flex-column align-items-center">
                    <img className="my-5" height="160px" src={itemImage} />
                    <a href={itemUrl} className="text-wrap mb-4 text-primary">
                        {itemTitle}
                    </a>
                    <div className="font-weight-bold">{formattedPrice}</div>
                </div>
            </div>
            <div className="row my-5 d-block d-md-none">
                <div className="col-12 d-flex">
                    <img className="mr-3" height="75px" src={itemImage} />
                    <div className="flex-grow-1">
                        <a href={itemUrl} className="mb-2 text-primary">
                            {itemTitle}
                        </a>
                        <div className="text-nowrap font-weight-bold">
                            {formattedPrice}
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default ItemDisplayConfirmed;
